import { Attachment } from '../../shared-components/models/attachment.model';
import { ProgramAndServiceDetail } from './programs-and-services-detail.model';
import { System } from '../../shared-components/System';
import { Student } from '../../shared-components/student/student.model';

export class ProgramAndService {

    // Properties
    id: number;
    Attachments: Attachment[];
    Comments: string;
    EntryDate = new Date(System.junkDateString);
    ExitDate = new Date(System.junkDateString);
    Id: number;
    ProgramAndServicesDetail: ProgramAndServiceDetail[];
    ProgramName: string;
    Sequence: number;
    ServiceName: string;
    private _sortedDetails: ProgramAndServiceDetail[];
    ProgramCodeId: number;
    ServiceCodeId: number;
    StudentId: number;
    FirstName = '';
    LastName = '';
    MiddleName = '';
    NickName = '';
    UserHasEditPermission = false;
    UserHasDeletePermission = false;
    // Selected Student for massupdate
    Students: Student[] = [];

    checked: false;
    // Class Functions
    get hasComments(): boolean {
        return this.Comments != null && this.Comments != undefined && this.Comments.length > 0;
    }

    get hasCommentsString(): string {
        return this.hasComments ? 'Y' : '';
    }

    get hasAttachments(): boolean {
        return this.Attachments != null && this.Attachments != undefined && this.Attachments.length > 0;
    }

    get hasAttachmentsString(): string {
        return this.hasAttachments ? 'Y' : '';
    }

    get detailsBySequence(): ProgramAndServiceDetail[] {
        if (!this._sortedDetails) {
            this._sortedDetails = this.ProgramAndServicesDetail.sort((a, b) => {
                return a.Sequence - b.Sequence;
            });
        }
        return this._sortedDetails;
    }
}
